import { ko } from 'date-fns/locale/ko';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { postPAIAF030, putMAKAB020, putMAKAB030 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SideNav from '../../../shared/components/SideNav';
import Tabs from '../../../shared/components/Tabs';
import useWindowWidth from '../../../shared/hooks/useWindowWidth';
import { decodeToken } from '../../../utils';
import PopupPAIAF030 from './PopupPAIAF030';
registerLocale('ko', ko);

const PAIAF030 = () => {
    const [searchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const page = searchParams.get('page') || 1;
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isPopupSendMailOpen, setIsPopupSendMailOpen] = useState(false);
    const [dataPopup, setDataPopup] = useState({});
    const closePopup = () => {
        setIsPopupSendMailOpen(false);
    };
    const handledataPopup = (item) => {
        setDataPopup(item);
        setIsPopupSendMailOpen(!isPopupSendMailOpen);
        if (item.readed === 'N' && item.type === 'REV') {
            putMAKAB030(item?.seq, decode?.memberID).then(() => {
                getListData();
            });
        }
    };
    const tabs = useMemo(
        () => [
            { label: '통합보기', isActive: true },
            { label: '받은쪽지', isActive: false },
            { label: '보낸쪽지', isActive: false },
        ],
        [],
    );

    const getListData = useCallback(() => {
        let params = { page };
        if (activeTabIndex === 1 && decode?.memberID) {
            params.options = { ToMemberID: [decode?.memberID] };
        } else if (activeTabIndex === 2 && decode?.memberID) {
            params.options = { FromMemberID: [decode?.memberID] };
        }
        postPAIAF030(params)
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    }, [page, activeTabIndex, decode?.memberID]);

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, activeTabIndex, getListData]);

    const handleTabChange = useCallback((index) => {
        setActiveTabIndex(index);
    }, []);

    const handleDelete = (item) => {
        if (window.confirm('삭제하시겠습니까?')) {
            putMAKAB020(item.seq, decode?.memberID)
                .then((res) => {
                    alert('삭제되었습니다.');
                    getListData();
                })
                .catch(() => {
                    alert('오류발생했습니다.');
                });
        }
    };
    const windowWidth = useWindowWidth();
    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume tabMy__message">
                            <div className="resume__inner">
                                <h3 className="resume__tit">My 쪽지</h3>
                                <div className="groupTab__message">
                                    <div className="wrap-titleMessage">
                                        <p>My 쪽지</p>
                                        <p>My message</p>
                                    </div>
                                    <Tabs tabs={tabs} className="short-tab" onTabChange={handleTabChange} />
                                </div>
                                {windowWidth >= 655 ? (
                                    <>
                                        {activeTabIndex === 0 && (
                                            <>
                                                <table className="msg__table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '12%' }}>구분</th>
                                                            <th style={{ width: '33%' }}>제목</th>
                                                            <th style={{ width: '15%' }}>발신인/수신인</th>
                                                            <th style={{ width: '15%' }}>발송일</th>
                                                            <th style={{ width: '15%' }}>열람일</th>
                                                            <th style={{ width: '10%' }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="msg__border-bottom">
                                                        {data && data.length > 0 ? (
                                                            data.map((item) => (
                                                                <tr key={item.seq}>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            onClick={() => {
                                                                                handleDelete(item);
                                                                            }}
                                                                        >
                                                                            삭제
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={6}>데이터없습니다</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                        {activeTabIndex === 1 && (
                                            <>
                                                <table className="msg__table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '12%' }}>구분</th>
                                                            <th style={{ width: '33%' }}>제목</th>
                                                            <th style={{ width: '15%' }}>발신인/수신인</th>
                                                            <th style={{ width: '15%' }}>발송일</th>
                                                            <th style={{ width: '15%' }}>열람일</th>
                                                            <th style={{ width: '10%' }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="msg__border-bottom">
                                                        {data && data.length > 0 ? (
                                                            data.map((item) => (
                                                                <tr key={item.seq}>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <button>삭제</button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={6}>데이터없습니다</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                        {activeTabIndex === 2 && (
                                            <>
                                                <table className="msg__table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '12%' }}>구분</th>
                                                            <th style={{ width: '33%' }}>제목</th>
                                                            <th style={{ width: '15%' }}>발신인/수신인</th>
                                                            <th style={{ width: '15%' }}>발송일</th>
                                                            <th style={{ width: '15%' }}>열람일</th>
                                                            <th style={{ width: '10%' }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="msg__border-bottom">
                                                        {data && data.length > 0 ? (
                                                            data.map((item) => (
                                                                <tr key={item.seq}>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <button>삭제</button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={6}>데이터없습니다</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {activeTabIndex === 0 && (
                                            <>
                                                <ul className="msg__table">
                                                    {data && data.length > 0 ? (
                                                        data.map((item) => (
                                                            <div className="msg__table-item" key={item.seq}>
                                                                <div className="msg__table-group">
                                                                    <li className="msg__row left">
                                                                        <div className="content-table-message">
                                                                            구분
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            제목
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발신인/수신인
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발송일
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            열람일
                                                                        </div>
                                                                    </li>
                                                                    <li className="msg__row right">
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                                <div className="flex-button-center">
                                                                    <button
                                                                        onClick={() => {
                                                                            handleDelete(item);
                                                                        }}
                                                                    >
                                                                        삭제
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <li>
                                                            <div
                                                                className="content-table-message"
                                                                style={{
                                                                    width: '100%',
                                                                    textAlign: 'center',
                                                                    marginTop: '30px',
                                                                }}
                                                            >
                                                                데이터없습니다
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>

                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                        {activeTabIndex === 1 && (
                                            <>
                                                <ul className="msg__table">
                                                    {data && data.length > 0 ? (
                                                        data.map((item) => (
                                                            <div className="msg__table-item" key={item.seq}>
                                                                <div className="msg__table-group">
                                                                    <li className="msg__row left">
                                                                        <div className="content-table-message">
                                                                            구분
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            제목
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발신인/수신인
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발송일
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            열람일
                                                                        </div>
                                                                    </li>
                                                                    <li className="msg__row right">
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                                <div className="flex-button-center">
                                                                    <button
                                                                        onClick={() => {
                                                                            handleDelete(item);
                                                                        }}
                                                                    >
                                                                        삭제
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <li>
                                                            <div
                                                                className="content-table-message"
                                                                style={{
                                                                    width: '100%',
                                                                    textAlign: 'center',
                                                                    marginTop: '30px',
                                                                }}
                                                            >
                                                                데이터없습니다
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>

                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                        {activeTabIndex === 2 && (
                                            <>
                                                <ul className="msg__table">
                                                    {data && data.length > 0 ? (
                                                        data.map((item) => (
                                                            <div className="msg__table-item" key={item.seq}>
                                                                <div className="msg__table-group">
                                                                    <li className="msg__row left">
                                                                        <div className="content-table-message">
                                                                            구분
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            제목
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발신인/수신인
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            발송일
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            열람일
                                                                        </div>
                                                                    </li>
                                                                    <li className="msg__row right">
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? '보낸쪽지'
                                                                                : item.type === 'REV'
                                                                                ? '받은쪽지'
                                                                                : ''}
                                                                        </div>
                                                                        <div
                                                                            className="content-table-message"
                                                                            onClick={() => handledataPopup(item)}
                                                                        >
                                                                            {item.title}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.type === 'SND'
                                                                                ? item.toMemberID
                                                                                : item.type === 'REV'
                                                                                ? item.fromMemberID
                                                                                : ''}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.sendDate}
                                                                        </div>
                                                                        <div className="content-table-message">
                                                                            {item.readDate}
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                                <div className="flex-button-center">
                                                                    <button
                                                                        onClick={() => {
                                                                            handleDelete(item);
                                                                        }}
                                                                    >
                                                                        삭제
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <li>
                                                            <div
                                                                className="content-table-message"
                                                                style={{
                                                                    width: '100%',
                                                                    textAlign: 'center',
                                                                    marginTop: '30px',
                                                                }}
                                                            >
                                                                데이터없습니다
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>

                                                <Pagination pages={pages} />
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isPopupSendMailOpen && (
                <PopupPAIAF030
                    closePopup={closePopup}
                    dataPopup={dataPopup}
                    activeTabIndex={activeTabIndex}
                    refreshData={getListData}
                />
            )}
        </>
    );
};

export default PAIAF030;
